import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { useContactUsDescendantIds } from 'client/pages/contact-us/entities/ContactUs'
import { EntityProps } from 'client/types'
import React from 'react'
import { useCalculateFormFieldStyles } from 'src/editor/shared/hooks/use-calculate-form-fields-styles'
import { Field } from 'src/shared/components/field'
import { ContactUsFieldEntityInterface } from 'src/shared/entities/contact-us-field/contact-us-field-entity.schema'

export const ContactUsField = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<ContactUsFieldEntityInterface>) => {
  const entityIds = useContactUsDescendantIds()

  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    calculatedTextAlign,
    calculatedColor,
    calculatedBackgroundColor,
  } = useCalculateFormFieldStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    fontSize: entity.fontSize,
    mobileFontSize: entity.mobileFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    textAlign: entity.textAlign,
    mobileTextAlign: entity.mobileTextAlign,
    color: entity.color,
    mobileColor: entity.mobileColor,
    backgroundColor: entity.backgroundColor,
    mobileBackgroundColor: entity.mobileBackgroundColor,
  })

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
      isRemoveAllowed={false}
      isSaveAllowed={false}
      isCopyAllowed={false}
      dropBoxAllowedEntityIds={entityIds}
    >
      <Field
        placeholder={entity.placeholder}
        padding={calculatedPadding.desktop}
        lineHeight={calculatedLineHeight.desktop}
        mobileLineHeight={calculatedLineHeight.mobile}
        textAlign={calculatedTextAlign.desktop}
        mobileTextAlign={calculatedTextAlign.mobile}
        mobilePadding={calculatedPadding.mobile}
        id={entity.htmlAttrId}
        border={calculatedBorder.desktop}
        mobileBorder={calculatedBorder.mobile}
        backgroundColor={calculatedBackgroundColor.desktop}
        mobileBackgroundColor={calculatedBackgroundColor.mobile}
        color={calculatedColor.desktop}
        mobileColor={calculatedColor.mobile}
        fontSize={calculatedFontSize.desktop}
        mobileFontSize={calculatedFontSize.mobile}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
      />
    </BaseEntityNew>
  )
}
